import SitesReportTable from "./ReportsTable";
import { getPendingSiteReport } from "../../services/ReportService/ReportService";

const PendingSitesReport = () => {
  return (
    <SitesReportTable
      fetchData={getPendingSiteReport}
      exportFileNamePrefix="OMC-Wise Pendency Report"
    />
  );
};

export default PendingSitesReport;
